<template>
  <div style="flex-basis: 20%;">
    <header class="categories__header">
      <h2 class="categories__title">Important Links {{sectionLinks}}</h2>
    </header>
    <ul class="categories__list">
      <li class="categories__item demo-listitem-active" v-for="(link,index) in links">
        <a href="#" class="categories__link" :class="{'demo-link-active': index == selected}" @click="navigateTo(index)">{{ link }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'demo-links',
    data () {
      let obj = {
        selected: undefined,
        links: ['Description', 'Available Sizes', 'Media Kit Material', 'Design Information']
      };
      return obj;
    },
    computed: {
      sectionLinks(){

      }
    },
    methods: {
      navigateTo (index) {
        this.selected = index;
        this.$emit('clicked', '' + index);
      }
    },
  }
</script>

<style>
  .demo-link-active {
    font-weight: bold;
    font-size: 17px;
    color: black;
    text-decoration: underline;
    border-left: 3px solid #1F5EE6;
    padding-left: 15px;
    margin-left: -15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/demo/DemoLinks.vue